import React,{useState,useEffect} from 'react'
import { getProjectNames } from '../../api/api'
import { useTheme } from '../../ThemeContext'; // Adjust the path as necessary
const ProjectNames = ({pname,handleChange,type}) => {
    // console.log(pname,handleChange)
    const { theme } = useTheme(); // Get the theme from context
    const [projectNames,setProjectNames]=useState([])
    useEffect(()=>{
        getProjectNames().then((res)=>{
            setProjectNames(res.data)
        })
    },[])
      return (
    <div>
        <label className="block text-sm font-medium mb-2">Project</label>
        <select onChange={handleChange} value={pname}  
       className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
       ><option value="" disabled>Select Project</option>
            {projectNames.map((c) => (

                <option key={c._id} value={c._id}>{c.project_name}</option>
            ))}
        </select>
    </div>
  )
}

export default ProjectNames